import { NQErrorCode, NQError } from '@visonum/network-quality-sdk';
import * as R from "ramda";
import { createNqError } from './createNqError';

export type FetchMethod = "GET" | "POST" | "PUT";

export const fetchRequest = async (url: string, method: FetchMethod, apiKey?: string, bodyData?: unknown, fetchTimeout = 60_000) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, fetchTimeout);

  try {
    const rawResponse = await fetch(url, {
      method: method,
      headers: R.isNil(apiKey) ? {
        "Content-Type": "application/json",
      } : {
        "Content-Type": "application/json",
        "X-APIKEY": apiKey,
      },
      body: R.isNil(bodyData) ? undefined : JSON.stringify(bodyData),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!rawResponse.ok) {
      const message = await rawResponse.text();
      throw new NQError(
        NQErrorCode.Server,
        `Fetch error. URL = "${url}". StatusCode: ${rawResponse.status}, Error message: "${message}"`
      );
    }

    return rawResponse;
  } catch (err) {
    if (err instanceof DOMException || err instanceof TypeError) {
      throw new NQError(NQErrorCode.Connectivity, `Fetch timeout: ${err.message}`, err);
    }

    throw createNqError(err);
  }
}
